import {useQuery} from "@tanstack/react-query";
import {categoriesGet} from "../api/categories/categoriesGet.ts";

export const useCategories = () => useQuery({
    queryKey: ['categories'],
    queryFn: () => categoriesGet().then(r => r.payload)
})